/**
 * One stored configuration value, read-only.
 *
 * A definition-list row rather than a disabled `<input>`. A greyed-out text field
 * says "you may edit this, just not right now"; this slice cannot save anything,
 * so a form control would be a promise the page does not keep. A `<dt>`/`<dd>`
 * pair says what it is — a stored value being reported — and it is what a screen
 * reader announces as a term and its definition.
 *
 * `missing` marks a value the backend named as a blocker. The mark is amber and
 * carries the word "fehlt", never colour alone.
 */
import React from "react";

export default function BexioSettingsField({ label, value, hint, missing = false }) {
  return (
    <div className="min-w-0 border-b border-border py-3 last:border-b-0">
      <dt className="text-xs font-medium text-muted-foreground">{label}</dt>
      <dd className="mt-1 min-w-0">
        <span
          className={`block break-words text-sm ${
            missing ? "text-amber-800 dark:text-amber-300" : "text-foreground"
          }`}
        >
          {value}
          {missing ? (
            <span className="ml-2 whitespace-nowrap text-xs font-medium">
              fehlt
            </span>
          ) : null}
        </span>
        {hint ? (
          <span className="mt-0.5 block text-xs text-muted-foreground">{hint}</span>
        ) : null}
      </dd>
    </div>
  );
}
